// extracted by mini-css-extract-plugin
module.exports = {"root":"subtitle_root___9g2X","sizemd":"subtitle_sizemd__gXXua"};